import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import Helmet from 'react-helmet';

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {mappingUI, dashboardRouter, titleCase} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    FacebookShareCount
} from 'react-share';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class OneReport extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            selectPic: 0
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = (id) => {
        api.openReport({_id: id})
            .then(json => {
                this.setState({data: json.data.data[0]});
                if (json.data.isError === false && json.data.data.length === 0) {
                    this.setState({notFound: {"deleted": "yes"}})
                }
            }).catch(error => {
            this.setState({notFound: error})
        });
    };

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data)
            return (
                <div>
                    <Helmet>
                        <title>
                            {data && data.patient_id && data.patient_id.user_id && data.patient_id.user_id.name ? titleCase(data.patient_id.user_id.name) : null}
                            : {data.title ? data.title.toUpperCase() : "No Title"}
                        </title>
                    </Helmet>
                    {this.state.alert}
                    <Grid container>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader>

                                    <GridContainer className="centerDiv">
                                        <GridItem xs={12} className="centerDiv">
                                            <h2><b>{data.title ? data.title.toUpperCase() : "No Title"}</b></h2>
                                        </GridItem>
                                    </GridContainer>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer className="centerDiv">
                                        {/*                                        <GridItem xs={8}>*/}
                                        <GridItem xs={12} className="centerDiv">
                                            <h4>
                                                <b>{data && data.patient_id && data.patient_id.user_id && data.patient_id.user_id.name ? titleCase(data.patient_id.user_id.name) : null}</b>
                                            </h4>
                                        </GridItem>
                                        <GridItem xs={12} className="centerDiv">
                                            <h4>{data.description ? data.description : null}</h4>
                                            <br/> <br/>
                                        </GridItem>

                                        <GridItem>
                                            <h5>{data ? "Uploaded By: " : null}</h5>
                                        </GridItem>
                                        <GridItem>
                                            <h4>{data && data.clinic_id ? data.clinic_id.name : "Self"}<br/>
                                            {data && data.doctor_id ? "Dr. " + data.doctor_id.user_id.name : null}</h4>
                                        </GridItem>
                                        <br/> <br/>
                                        {/*
                                         <GridItem xs={12}>
                                         <GridItem>
                                         <h3>
                                         <b>{data && data.patient_id ? data.patient_id.user_id.name : null}</b>
                                         </h3>
                                         <b>{data && data.patient_id ? data.patient_id.user_id.gender : null}</b>
                                         <b>{data && data.patient_id ? data.patient_id.user_id.contact : null}</b>
                                         <b>{data && data.patient_id ? data.patient_id.user_id.email : null}</b>
                                         </GridItem>

                                         </GridItem>*/}

                                        {/*                                        </GridItem>*/}
                                    </GridContainer><br/> <br/> <br/>
                                    <GridContainer className="centerDiv">

                                        {data.report_link.map((item, index) => {
                                            return <div onClick={() => this.setState({selectPic: index})}
                                                        key={Math.random()} style={this.state.selectPic === index ? {
                                                padding: '10px',
                                                margin: '10px',
                                                border: '1px solid',
                                                background: '#39abc1',
                                                color: 'white'
                                            } : {
                                                padding: '10px',
                                                margin: '10px',
                                                border: '1px solid',
                                                background: '#fff',
                                                color: 'black'
                                            }}>{item.type !== "" ? `${item.type} ${index + 1}` : `Others ${index + 1}`}</div>
                                        })}
                                    </GridContainer> <br/> <br/> <br/>
                                    {data.paid ? <GridContainer className="centerDiv">
                                        {data.report_link.length > 0 ? showReport(data.report_link[this.state.selectPic].link) : null}
                                        <br/> <br/> <br/>
                                    </GridContainer> : null}
                                    {data.paid ? <GridContainer className="centerDiv">
                                        <a href={data.report_link[this.state.selectPic].link} download>
                                            <Button block size="lg" color="success">
                                                Download
                                            </Button></a>&nbsp;&nbsp;&nbsp;
                                        {/*<a href="#">
                                         <Button block size="lg" color="success" onClick={() => {*/}
                                        {/*window.print();*/}
                                        {/*return false*/}
                                        {/*}}>*/}
                                        {/*Print*/}
                                        {/*</Button>
                                         </a>*/}
                                    </GridContainer> : <GridContainer className="centerDiv">
                                        <b className="text-center">Please make payment to view your report</b>
                                    </GridContainer>}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        } else return (
            <div>
                <Loader/>
            </div>
        )
    }
}

export default withStyles(styles)(OneReport);

function showReport(url) {
    var type = url.substr(-3).toLowerCase();
    switch (type) {
        case ("pdf"):
            return <object data={url}
                           type="application/pdf"
                           width="800" height="1200">
                <div className="centerDiv"
                     style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                    href={url}>
                    <Button block size="lg" color="success">
                        Open Report
                    </Button></a></div>
            </object>;
        case ("doc"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("docx"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("rtf"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("dot"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case("jpeg"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        case("jpg"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        case ("png"):
            return <a href={url} download>
                <img
                    style={{maxWidth: '100%'}}
                    src={url}/></a>;
        default:
            return <div className="centerDiv"
                        style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                href={url}><Button block
                                   size="lg"
                                   color="success">
                Open Report
            </Button></a></div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Reports/oneOpenReport.jsx